import { Stage } from '@eventbrite/webapp-constants';
import React, { createContext, useContext } from 'react';

const CSRFTokenContext = createContext<string>('');
const StageContext = createContext<Stage>(Stage.PROD);

export const useCSRFToken = () => useContext(CSRFTokenContext);
export const useStage = () => useContext(StageContext);

export const CSRFTokenProvider: React.FC<{ csrfToken: string; children: React.ReactNode }> = ({
  csrfToken,
  children,
}) => {
  return <CSRFTokenContext.Provider value={csrfToken}>{children}</CSRFTokenContext.Provider>;
};

export const StageProvider: React.FC<{ stage: Stage; children: React.ReactNode }> = ({
  stage,
  children,
}) => {
  return <StageContext.Provider value={stage}>{children}</StageContext.Provider>;
};
